










import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class Forbidden extends Vue {
  mounted(): void {
    setTimeout(() => {
      this.$router.replace("/");
    }, this.$second(1));
  }
}
